import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
//Components
import {DefaultComponent} from '../default/default/default.component';
import {MenuComponent} from '../components/menu/menu.component';
//Modules
import { DefaultRoutingModule } from './default-routing.module';
import  {UtilModule} from '../util/util.module';

import { IconsModule } from 'src/app/icons/icons.module';
import { MenuModule } from '../components/menu/menu.module';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

const NgxBootstrapModule = [
  PopoverModule.forRoot(),
  ModalModule.forRoot(),
  TooltipModule.forRoot()
]
@NgModule({
  declarations: [
    DefaultComponent,
    MenuComponent
  ],
  imports: [
    CommonModule,
    DefaultRoutingModule,
    UtilModule,
    PopoverModule,
    ModalModule,
    TooltipModule,
    IconsModule,
    RouterModule,
    NgxBootstrapModule,
    //MenuModule
  ]
})
export class DefaultModule { }
